import React from "react";

import { createSnackbar } from "utils/createSnackbar";

import instance from "api/v1";
import { useAuth } from "hooks/useAuth";

export function useDeleteProgramsMeta() {
  // @ts-ignore
  const { user } = useAuth();
  const apiInstance = instance(user);

  return React.useCallback(
    (programsMetaId: number, programsMeta: [], setProgramsMeta: any) => {
      const fetch = async () => {
        await apiInstance
          .delete(`/general-pages/${programsMetaId}`)
          .then(() => {
            createSnackbar("Programs meta tags deleted successfully");
            setProgramsMeta(programsMeta.filter((item: any) => item.id !== programsMetaId));
          })
          .catch((error) => {
            console.error(error);
            if (error.response) createSnackbar(error.response.data.message);
            else createSnackbar("Something went wrong");
          });
      };
      fetch();
    },
    [],
  );
}
